export const normalizeStr = (str) => {// remove accent and lower case str
    str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()
    return str
}

export const MONTHS = [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre",
]

export const COLORCODES = {
    lavande : "#7986CB",
    sauge: "#33B679",
    bleu: "#039BE5",
    violet: "#8E24AA",
    rose: "#E67C73",
    jaune: "#F6BF26"
}
export const SCHCOLORS = {
    ABS : COLORCODES.lavande,
    CHANTIER: COLORCODES.bleu,
    PROJECT: COLORCODES.violet,
    OTHER: COLORCODES.jaune,
}

// Fonction utilitaire pour vider tous les caches et recharger la page
export const clearAllCachesAndReload = () => {
    console.log('Nettoyage des caches et rechargement...');
    
    // Nettoyer le localStorage
    try {
        localStorage.clear();
        console.log('localStorage vidé');
    } catch (e) {
        console.log('Erreur lors du nettoyage du localStorage:', e);
    }
    
    // Nettoyer le sessionStorage
    try {
        sessionStorage.clear();
        console.log('sessionStorage vidé');
    } catch (e) {
        console.log('Erreur lors du nettoyage du sessionStorage:', e);
    }
    
    // Nettoyer les cookies
    try {
        document.cookie.split(";").forEach(function(c) { 
            document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
        });
        console.log('Cookies nettoyés');
    } catch (e) {
        console.log('Erreur lors du nettoyage des cookies:', e);
    }
    
    // Nettoyer le cache du service worker si disponible
    if ('caches' in window) {
        caches.keys().then(function(names) {
            console.log('Nettoyage des caches du service worker...');
            return Promise.all(
                names.map(function(name) {
                    console.log('Suppression du cache:', name);
                    return caches.delete(name);
                })
            );
        }).then(function() {
            console.log('Tous les caches du service worker ont été supprimés');
            // Recharger la page en forçant le rechargement depuis le serveur
            window.location.reload(true);
        }).catch(function(error) {
            console.log('Erreur lors du nettoyage des caches:', error);
            // Fallback: recharger quand même
            window.location.reload(true);
        });
    } else {
        console.log('API Cache non disponible, rechargement direct');
        // Fallback pour les navigateurs qui ne supportent pas l'API Cache
        window.location.reload(true);
    }
}

// Fonction pour forcer le rechargement d'une URL spécifique avec nettoyage de cache
export const reloadWithCacheBust = (url = null) => {
    const targetUrl = url || window.location.href;
    const separator = targetUrl.includes('?') ? '&' : '?';
    const cacheBustUrl = `${targetUrl}${separator}_cacheBust=${Date.now()}`;
    
    if (url) {
        // Si une URL spécifique est fournie, naviguer vers cette URL
        window.location.href = cacheBustUrl;
    } else {
        // Sinon, recharger la page actuelle
        window.location.reload(true);
    }
}

// Fonction spécifique pour nettoyer les iframes et leurs caches
export const clearIframesCache = () => {
    console.log('Nettoyage spécifique des caches iframe...');
    
    // Nettoyer toutes les iframes présentes sur la page
    const iframes = document.querySelectorAll('iframe');
    iframes.forEach((iframe, index) => {
        try {
            // Essayer de nettoyer le cache de l'iframe
            if (iframe.contentWindow && iframe.contentWindow.location) {
                iframe.contentWindow.location.reload(true);
                console.log(`Cache iframe ${index} rechargé avec force`);
            }
            
            // Nettoyer l'URL pour forcer un nouveau chargement
            const currentSrc = iframe.src;
            if (currentSrc && currentSrc !== 'about:blank') {
                const separator = currentSrc.includes('?') ? '&' : '?';
                iframe.src = `${currentSrc}${separator}_cacheBust=${Date.now()}`;
                console.log(`URL iframe ${index} mise à jour avec cache bust`);
            }
        } catch (error) {
            console.log(`Erreur lors du nettoyage cache iframe ${index}:`, error);
            // Fallback : naviguer vers about:blank puis recharger
            try {
                const originalSrc = iframe.src;
                iframe.src = 'about:blank';
                setTimeout(() => {
                    if (originalSrc && originalSrc !== 'about:blank') {
                        const separator = originalSrc.includes('?') ? '&' : '?';
                        iframe.src = `${originalSrc}${separator}_cacheBust=${Date.now()}`;
                    }
                }, 50);
            } catch (fallbackError) {
                console.log(`Fallback iframe ${index} échoué:`, fallbackError);
            }
        }
    });
}

// Fonction utilitaire pour ajouter un bouton de rechargement avec nettoyage de cache
export const addClearCacheButton = (containerId = 'cache-clear-container') => {
    const container = document.getElementById(containerId);
    if (container) {
        const button = document.createElement('button');
        button.textContent = 'Vider le cache et recharger';
        button.style.cssText = `
            padding: 10px 15px;
            background-color: #f44336;
            color: white;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            font-size: 14px;
            margin: 10px;
        `;
        button.addEventListener('click', clearAllCachesAndReload);
        container.appendChild(button);
    }
}
